export default __webpack_public_path__ + "static/media/Blade of the Black Pharaoh.334aa4e3.jpg";